import React from "react";
import { Box, Typography } from "@mui/material";
import { SHOWCASE_CARDS } from "../../utils/triviaShareCardLab";
import TriviaShareCardScene from "../trivia/TriviaShareCardScene";
import MarketingProductSection from "./MarketingProductSection";
import MarketingTriviaPlayPreview from "./MarketingTriviaPlayPreview";

const MarketingTriviaSection = ({ onPlay }) => (
  <MarketingProductSection
    tone="black"
    chip="Trivia Arcade"
    title="Play the board. Earn the card."
    body="Daily, Quick Play, and Custom — same questions as the arcade. Finish a Daily and take home a 3D Stats.fan card. Perfect boards go gold."
    ctaLabel="Play Daily Trivia"
    onCta={onPlay}
  >
    <Box sx={{ mb: 5 }}>
      <MarketingTriviaPlayPreview onPlay={onPlay} />
    </Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: { xs: 2, md: 6 },
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <TriviaShareCardScene card={SHOWCASE_CARDS.teal} />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
          Daily · teal
        </Typography>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <TriviaShareCardScene card={SHOWCASE_CARDS.gold} />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
          Flawless · gold
        </Typography>
      </Box>
    </Box>
  </MarketingProductSection>
);

export default MarketingTriviaSection;
